import { render, staticRenderFns } from "./phonePopup.vue?vue&type=template&id=6071467c&scoped=true"
import script from "./phonePopup.vue?vue&type=script&lang=js"
export * from "./phonePopup.vue?vue&type=script&lang=js"
import style0 from "./phonePopup.vue?vue&type=style&index=0&id=6071467c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071467c",
  null
  
)

export default component.exports